import {
  AccordionSummary,
  Box,
  Button,
  Chip,
  IconButton,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useSearchParams } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";

const days = [
  { name: "monday", label: "Monday" },
  { name: "tuesday", label: "Tuesday" },
  { name: "wednesday", label: "Wednesday" },
  { name: "thursday", label: "Thursday" },
  { name: "friday", label: "Friday" },
  { name: "saturday", label: "Saturday" },
  { name: "sunday", label: "Sunday" },
];

const DayOfWeek = ({ type, onDaysChange }) => {
  const [selectedDays, setSelectedDays] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const daysParam = searchParams.get("days");
    if (daysParam) {
      setSelectedDays(JSON.parse(daysParam));
    }
  }, [searchParams]);

  useEffect(() => {
    if (type === "Accordion") {
      onDaysChange(selectedDays);
    }
  }, [selectedDays]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "day-of-week" : undefined;

  useEffect(() => {
    if (open) {
      document.documentElement.style.overflow = "hidden";
      document.documentElement.style.paddingRight = "17px";
    } else {
      document.documentElement.style.overflow = "";
      document.documentElement.style.paddingRight = "";
    }
  }, [open]);

  const handleDayChange = (event) => {
    const { name, checked } = event.target;
    if (checked) {
      setSelectedDays((prev) => [...prev, name]);
    } else {
      setSelectedDays((prev) => prev.filter((day) => day !== name));
    }
  };

  const handleDaysClear = () => {
    setSelectedDays([]);
  };

  const handleApplyClick = () => {
    setSearchParams({
      ...Object.fromEntries(searchParams),
      days: JSON.stringify(selectedDays),
    });

    handleClose();
  };

  const checkboxes = days.map((day) => (
    <FormControlLabel
      key={day.name}
      control={
        <Checkbox
          name={day.name}
          checked={selectedDays.includes(day.name)}
          onChange={handleDayChange}
        />
      }
      label={day.label}
    />
  ));

  if (type === "Accordion") {
    return (
      <Accordion sx={{ backgroundColor: "#f7f7f7" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="day-of-week-content"
          id="day-of-week-header"
        >
          <Typography>Day of Week</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormControl component="fieldset" variant="standard">
            <FormGroup>{checkboxes}</FormGroup>
          </FormControl>
        </AccordionDetails>
      </Accordion>
    );
  } else {
    return (
      <>
        <Chip
          label="Day of Week"
          variant="outlined"
          color="white"
          onClick={handleClick}
          sx={{ width: "100%", fontSize: { xs: "0.69rem", sm: "0.8125rem" } }}
        />
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          sx={{ marginTop: "-32px", borderRadius: "25px" }}
          slotProps={{ paper: { sx: { borderRadius: "16px" } } }}
        >
          <Box sx={{ borderRadius: "25px", padding: "0", width: "195px" }}>
            <Stack spacing={2}>
              <Chip
                label="Day of Week"
                variant="outlined"
                color="white"
                // onClick={handleClick}
                sx={{
                  width: "100%",
                  fontSize: { xs: "0.69rem", sm: "0.8125rem" },
                  backgroundColor: "#0B3C65",
                }}
              />
              {/*<Box*/}
              {/*  sx={{*/}
              {/*    display: "flex",*/}
              {/*    justifyContent: "space-between",*/}
              {/*    alignItems: "center",*/}
              {/*  }}*/}
              {/*>*/}
              {/*  <Typography variant="button" display="block">*/}
              {/*    Day od Week*/}
              {/*  </Typography>*/}

              {/*  <IconButton aria-label="clear" onClick={handleClose}>*/}
              {/*    <CloseIcon />*/}
              {/*  </IconButton>*/}
              {/*</Box>*/}
              <Box sx={{ padding: "0 18px 18px 18px" }}>
                <Box
                  sx={{
                    height: 200,
                    overflow: "auto",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  className="scroll--simple"
                >
                  <FormControl component="fieldset" variant="standard">
                    <FormGroup>{checkboxes}</FormGroup>
                  </FormControl>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Button size="small" variant="text" onClick={handleDaysClear}>
                    clear
                  </Button>
                  <Button
                    color="yellow"
                    variant="contained"
                    sx={{
                      borderRadius: "25px",
                      marginTop: "2px",
                      fontWeight: 600,
                    }}
                    onClick={handleApplyClick}
                  >
                    Apply
                  </Button>
                </Box>
              </Box>
            </Stack>
          </Box>
        </Popover>
      </>
    );
  }
};

export default DayOfWeek;
